import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { dProductsChangeVATSagaAC } from 'model/dashboardProducts/dProductsActionCreators'
import { IdProductsState } from 'model/dashboardProducts/dProductsReducer'
import { NULL_VALUE, SelectBox } from 'components/UI/SelectBox/SelectBox';
import { vatList } from 'constants/vatAllowedValue';


// Types
export type typePopupChangeVAT = {
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeBulkChangeVATObject = {
    id: string,
    vat: number,
}

// Component
export const PopupChangeVAT: React.FC<typePopupChangeVAT> = ({ setOpenPopup }) => {

    const dispatch = useDispatch()

    // System data
    const filters = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.filters)
    const pagination = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.pagination)


    // Form data
    const [ vatValue, setVatValue ] = useState<number | typeof NULL_VALUE.id>(NULL_VALUE.id)

    // Validation
    const [ validationObj, setValidationObj ] = useState({
                                                             requiredVat: false,
                                                         })

    useEffect(() => {

        if ( vatValue === NULL_VALUE.id || vatValue === null) {
            setValidationObj((v) => {
                return { ...v, ...{ requiredVat: false } }
            })
        } else {
            setValidationObj((v) => {
                return { ...v, ...{ requiredVat: true } }
            })
        }
    }, [ vatValue ])


    // Add product
    const onChangeVATHandler = async (e: React.FormEvent) => {
        e.preventDefault()

        if ( vatValue === NULL_VALUE.id) {
            setValidationObj((v) => {
                return { ...v, ...{ requiredVat: false } }
            })
        }
        if (typeof vatValue === 'number') {
            dispatch(dProductsChangeVATSagaAC(filters, {
                page: pagination.pageNumber,
                size: pagination.itemsPerPage!
            }, vatValue))
            setOpenPopup(false)
        }
    }

    return (
        <form onSubmit={ (e) => onChangeVATHandler(e) }>

            <div className="relative">

                <div className="relative md:w-80">

                    <div>
                        <SelectBox
                            id="vat"
                            label={ <Trans>VAT in %</Trans> }
                            valuesList={ vatList }
                            required={ true }
                            valueId={ vatValue }
                            setIdValue={ setVatValue }
                            labelClassname="text-left"
                            errorMessage={ validationObj.requiredVat ? undefined : <Trans>Required field</Trans> }
                        />
                    </div>
                </div>

                <div className="flex gap-4 mt-5 sm:mt-2 sm:flex sm:flex-row-reverse">

                    <Button
                        type="submit" label={ <Trans>Add</Trans> }
                    />

                    <Button
                        type="button"
                        secondary={ true } label={ <Trans>Cancel</Trans> }
                        onClick={ () => setOpenPopup(false) }
                    />

                </div>

            </div>

        </form>

    )
}
